<template>
    <div class="none_margin">
        <van-icon name="cross" class="cross" @click="close" />
        <van-image :src="require('../../assets/bx/acc/nomargin.png')" class="img" />
        <p>保证金不足</p>
        <van-button round color="var(--theme)" @click="recharge">前往充值</van-button>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            close() {
                this.$emit("closeModal");
            },
            recharge() {
                this.$emit("success");
            },
        },
        watch: {},
    };
</script>

<style lang="less" scoped>
    .none_margin {
        position: relative;
        padding: 2.9rem 1.5rem 2.2rem;

        .cross {
            position: absolute;
            right: 0.8rem;
            top: 0.8rem;
            font-size: 1.8rem;
            color: #000;
            cursor: pointer;
        }

        .img {
            width: 4.9rem;
            height: 4.7rem;
            display: block;
            margin: 0 auto 1.6rem;
        }

        p {
            font-size: 1.6rem;
            font-weight: 700;
            color: #000;
            text-align: center;
            margin-bottom: 2.8rem;
        }

        .van-button {
            width: 100%;
            height: 3.2rem;
            padding: 0;
            font-size: 1.4rem;
        }
    }
</style>